module.exports = __webpack_public_path__ + "img/clip_image086.c6bb99a8.png";